import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchWithResponse } from 'src/Types/api'
import { FUNCTION_NUMBER } from '../types/common'
import { GridAndSystemProtectionForm } from '../types/schemas'
import { fromFormToUpdateDto } from './transformers'

type Payload = Partial<GridAndSystemProtectionForm>

export const updateGridAndSystemProtectionSettings = async (
  storageId: string | null | undefined,
  functionNumber: FUNCTION_NUMBER,
  authFetch: AuthFetchWithResponse,
  payload: Payload
): Promise<null> => {
  if (!storageId) return null
  try {
    const mappedPayload = fromFormToUpdateDto(payload)
    if (mappedPayload === null) {
      throw new Error('No valid payload to update grid and system protection settings')
    }

    const response = await authFetch<null>({
      path: `storages/${storageId}/hardware/protection/${functionNumber}`,
      method: 'PUT',
      payload: mappedPayload,
    })

    if (response.status !== StatusCodes.NO_CONTENT) {
      throw new Error('Failed to update grid and system protection settings')
    }

    return null
  } catch (error) {
    throw new Error('Failed to update grid and system protection settings: ' + (error as Error).message)
  }
}
